export enum ResponseLength {
  EXTREMELY_BRIEF = "EXTREMELY_BRIEF",
  CONCISE = "CONCISE",
  MODERATE = "MODERATE",
  DETAILED = "DETAILED",
  COMPREHENSIVE = "COMPREHENSIVE",
}

/**
 * The length a team gets until it chooses one. The slider is no longer on the
 * settings page, so this is what new teams and generated personalities use.
 */
export const DEFAULT_OUTPUT_LENGTH = ResponseLength.CONCISE;
